import {createSelector} from 'reselect';
import {RootState} from '../types/store';

export const selectAppThemeRoot = createSelector(
  (state: RootState) => state.appTheme,
  appTheme => appTheme
);

export const selectAppTheme = createSelector(selectAppThemeRoot, appTheme => appTheme.theme);
